(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.form_input').forEach(function (input) {
    const label = input.previousElementSibling;

    input.addEventListener('input', function () {
      if (input.value.trim() !== '') {
        label.classList.add('hidden');
      } else {
        label.classList.remove('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
